import { API } from '../config/AppConfig';
import {
  MICROSOFT_SIGNUP
} from '../constants/Endpoints';

class MicrosoftAuthRepository {
    async sso_signup(payload){
        const response = await API.post(MICROSOFT_SIGNUP, {
            body: payload,
        })
        return response;
    }
    
}

const microsoftAuthRepository = new MicrosoftAuthRepository();
export default microsoftAuthRepository;